import { Col, Row } from "antd";
import styled, { css } from "styled-components";
import { theme } from "../../../config";

const CommonWrapperStyles = css`
  border-radius: 0px 0px 0px 0px;
  background: ${theme.colors.white};
  margin-bottom: 50px;
`;

export const DetailsWrapper = styled.div`
  ${CommonWrapperStyles}
  padding: 48px 74px 40px 74px;

  .ant-input[disabled],
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector,
  .ant-input-number-disabled,
  .ant-picker.ant-picker-disabled {
    background: ${theme.colors.neutral.black7};
  }

  .ant-radio-disabled .ant-radio-inner {
    border-color: ${theme.colors.neutral.black4} !important ;
  }

  .ant-radio-disabled + span {
    color: ${theme.colors.neutral.black4};
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: ${theme.colors.radioPrimaryDisabled} !important ;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: ${theme.colors.radioPrimaryDisabled};
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: ${theme.colors.radioPrimaryDisabled};
  }

  .ant-radio-checked + span {
    color: ${theme.colors.radioText};
  }
`;

export const LogsWrapper = styled.div`
  ${CommonWrapperStyles}
  padding: 21px 0 36px 21px;
  height: ${theme.screenHeight - 400}px;
  overflow: auto;
`;

export const SkillsRow = styled(Row)`
  margin-bottom: 23px;
`;

const TitleStyle = css`
  color: ${theme.colors.dark};

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    line-height: 16px;
  }
`;

export const CharRefTitle = styled.div`
  margin-top: 30px;
  margin-bottom: -17px;
  ${TitleStyle}
`;

export const ParagraphTitle = styled.div`
  margin-top: 20px;
  ${TitleStyle}
`;

export const CharRefRow = styled(Row)`
  margin-top: 32px;
`;

export const SkillsNameCol = styled(Col)`
  text-align: right;
  word-wrap: break-word;
`;

export const SkillsName = styled(Col)`
  font-size: 16px;
  
  @media (min-width: 576px) {
    text-align: left;
  }
`;

export const TooltipStyled = styled.div`
  .ant-tooltip-inner {
    color: ${theme.colors.gray6};
    background-color: ${theme.colors.custom.darkblue3};
    border-radius: 4px;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const ResumeButtonsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 12px;
`;
